import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import {
    Activity,
    ActivitySearchableRequest,
    DAT,
    DATRequest,
    PaginateResponse,
    Response,
    SearchableRequest,
} from '../model';
import { composeUrl } from 'app/core/shared/helper/url.helper';
import { DATState } from 'app/modules/daily-activity-tracker/state/dat.state';

@Injectable({ providedIn: 'root' })
export class DailyTrackerService {
    constructor(private _httpClient: HttpClient, private state: DATState) {}

    getDailyActivityTracker(
        params: any
    ): Observable<Response<PaginateResponse<DAT>>> {
        const url = composeUrl(
            `/v1/DailyActivityTracker/GetDailyTrackerList`,
            params
        );
        return this._httpClient.get<Response<PaginateResponse<DAT>>>(url).pipe(
            take(1),
            this.state.resolveStore((response) => {
                const records = response.data.data.map((record) => {
                    return record;
                });
                return { records };
            })
        );
    }

    getDailyActivity(
        params: SearchableRequest
    ): Observable<Response<PaginateResponse<DAT>>> {
        const url = composeUrl(
            `/v1/DailyActivityTracker/GetDailyTrackerList`,
            params
        );
        return this._httpClient.get<Response<PaginateResponse<DAT>>>(url).pipe(
            take(1),
            this.state.resolveStore((response) => {
                const records = response.data.data.map((record) => {
                    return record;
                });
                return { records };
            })
        );
    }

    getDailyActivityDetails(
        params: ActivitySearchableRequest
    ): Observable<Response<PaginateResponse<Activity>>> {
        const url = composeUrl(
            `/v1/DailyActivityTracker/GetDailyTrackerDetailsList`,
            params
        );
        return this._httpClient.get<Response<PaginateResponse<Activity>>>(url).pipe(
            take(1),
        );
    }

    updateDailyActivityTracker(payload: DATRequest): Observable<any> {
        const url = composeUrl(`/v1/DailyActivityTracker/UpdateDailyTracker`);
        return this._httpClient.post<any>(url, payload);
    }

    deleteDailyActivity(id: string): Observable<any> {
        const url = composeUrl(
            `/v1/DailyActivityTracker/DeleteDailyTrackerDetails`,
            {
                id,
            }
        );
        return this._httpClient.delete<any>(url);
    }

    downloadExcel(url: string) {
        this._httpClient
            .get(url, { responseType: 'blob' })
            .subscribe((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `Daily Activity Tracker.xlsx`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            });
    }
}
